import {
  GridValidRowModel,
  GridRenderCellParams,
  GridTreeNodeWithRender,
  GridRenderEditCellParams,
} from '@mui/x-data-grid-pro';
import { ReactNode } from 'react';

import { NULLISH_VALUE } from '~/common/constants';

export type RenderCellType<
  R extends GridValidRowModel = any,
  V = any,
  F = V,
  N extends GridTreeNodeWithRender = GridTreeNodeWithRender,
> = (params: GridRenderCellParams<R, V, F, N>) => ReactNode;

export type RenderEditCellType<
  R extends GridValidRowModel = any,
  V = any,
  F = V,
  N extends GridTreeNodeWithRender = GridTreeNodeWithRender,
  AdditionalProps = any,
> = (params: GridRenderEditCellParams<R, V, F, N> & AdditionalProps) => ReactNode;

export const NULLISH_CELL_VALUE = NULLISH_VALUE;

export enum GridAlignmentType {
  LEFT = 'left',
  RIGHT = 'right',
  CENTER = 'center',
}
export enum GridSortDirectionType {
  ASC = 'asc',
  DESC = 'desc',
}

export enum GridDensityType {
  COMPACT = 'compact',
  STANDARD = 'standard',
  COMFORTABLE = 'comfortable',
}

export enum TextFieldCellType {
  TEXT = 'text',
  NUMBER = 'number',
}
